/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dropbox_Failed_FilesInputs */

const en_dropbox_failed_files = /** @type {(inputs: Dropbox_Failed_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} file could not be added. It stays selected so you can retry.`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} files could not be added. They stay selected so you can retry.`);
	return /** @type {LocalizedString} */ ("dropbox_failed_files");
};

const es_dropbox_failed_files = /** @type {(inputs: Dropbox_Failed_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`No se pudo añadir ${i?.count} archivo. Sigue seleccionado para que puedas reintentarlo.`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`No se pudieron añadir ${i?.count} archivos. Siguen seleccionados para que puedas reintentarlos.`);
	return /** @type {LocalizedString} */ ("dropbox_failed_files");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} file could not be added. It stays selected so you can retry." |
* | "other" | "{count} files could not be added. They stay selected so you can retry." |
*
* @param {Dropbox_Failed_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_failed_files = /** @type {((inputs: Dropbox_Failed_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Failed_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_failed_files(inputs)
	return en_dropbox_failed_files(inputs)
});